import React from 'react';

import { Badge } from 'src/common/ui/components';
import { PrescriptionTaskStatus } from 'src/prescriptionTasksQueue/PrescriptionTaskStatus';

interface PrescriptionTaskStatusBadgeProps {
  status: PrescriptionTaskStatus;
}

const PrescriptionTaskStatusBadge: React.FC<PrescriptionTaskStatusBadgeProps> = ({ status }) => {
  switch (status) {
    case PrescriptionTaskStatus.Pending:
      return <Badge label="Pending" color="warning" icon="warning" rounded />;
    case PrescriptionTaskStatus.Accepted:
      return <Badge label="Accepted" color="info" icon="infoOutlined" rounded />;
    case PrescriptionTaskStatus.Completed:
      return <Badge label="Completed" color="success" icon="check" rounded />;
    case PrescriptionTaskStatus.Canceled:
      return <Badge label="Canceled" color="error" icon="delete" rounded />;
    default:
      return <Badge label="Unknown" color="error" icon="delete" rounded />;
  }
};

export default PrescriptionTaskStatusBadge;
